import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { variables } from '../../../assets/styles/variables';
import themeColors from '../../../assets/styles/themeColors';
import {
  uButtonClear,
  uFullWidth,
  uOutlineNone,
} from '../../../assets/styles/utility';
import { pxToRem } from '../../../assets/styles/helper';
import Ribbon from './Ribbon';

const CardButtonWrapper = styled.div`
  border: 1px solid ${themeColors.colorPrimaryLight};
  background-color: ${themeColors.colorWhite};
  border-radius: ${variables.borderRadius.borderRadius};
  position: relative;
  margin-bottom: 16px;
`;

const CardButtonElement = styled.button`
  ${uButtonClear};
  ${uOutlineNone};
  cursor: pointer;
  ${uFullWidth};
  padding: ${pxToRem(10)} ${pxToRem(12)};
  cursor: ${(props) => (props.disabled ? 'not-allowed' : 'pointer')};
  display: flex;
  flex-direction: column;
  align-items: flex-start;
`;

const CardButtonTitleWrapper = styled.div`
  display: flex;
  align-items: center;
  margin-bottom: 10px;
`;

const CardButtonTitle = styled.h3`
  font-family: ${variables.family.goldSilver};
  font-size: ${pxToRem(16)};
  font-weight: 500;
  color: ${themeColors.colorTextPrimary};
  margin: 0 12px 0 6px;
`;

const CardButtonIcon = styled.div`
  width: 32px;
  height: 32px;
  background-color: ${themeColors.colorGrey};
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: ${variables.borderRadius.borderRadius};

  svg {
    width: 22px;
  }
`;

const CardButtonTag = styled.div`
  background-color: ${themeColors.colorBrandLight};
  padding: 4px 6px;
  border-radius: ${variables.borderRadius.borderRadiusSm};
  color: ${themeColors.colorTextPrimary};
  font-size: ${pxToRem(14)};
  font-weight: 400;
`;

export const CardButtonContentItem = styled.p`
  color: ${themeColors.colorTextSecondary};
  font-size: 14px;
  font-weight: 400;
  padding: 6px 0;
`;

export const CardButtonNote = styled.div`
  display: flex;
  align-items: center;
  font-size: 12px;
  font-weight: 400;
  color: ${themeColors.colorTextPrimary};
  opacity: 0.8;

  svg {
    margin-right: 4px;
    fill: ${themeColors.colorTextSecondary};
  }
`;

const CardButton = ({ title, icon, tag, onButtonClick, ribbon, content }) => (
  <CardButtonWrapper>
    <CardButtonElement onClick={onButtonClick}>
      {ribbon && <Ribbon fontSize="14px">{ribbon}</Ribbon>}
      <CardButtonTitleWrapper>
        <CardButtonIcon>{icon}</CardButtonIcon>
        <CardButtonTitle>{title}</CardButtonTitle>
        {tag && <CardButtonTag>{tag}</CardButtonTag>}
      </CardButtonTitleWrapper>
      {content}
    </CardButtonElement>
  </CardButtonWrapper>
);

CardButton.propTypes = {
  title: PropTypes.string,
  icon: PropTypes.node,
  tag: PropTypes.bool,
  onButtonClick: PropTypes.func,
  ribbon: PropTypes.bool,
  content: PropTypes.node,
};

export default CardButton;
